import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem("user") || "{}") || {
      id: "",
      username: "",
      rut: "",
      email: "",
      phone: "",
      lenguage: "es",
      direccion: "",
      calle: "",
      numero: "",
      zona: ""
    },
    solicitud: JSON.parse(localStorage.getItem("solicitud") || "{}") || {
      parentesco: null as number | null,
      nombre: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      rut: "",
      fechaNacimiento: null as Date | null,
      estadoCivil: null as number | null,
      sexo: null as number | null,
      nacionalidad: null as number | null,
      calle: "",
      calle_id: null as number | null,
      comuna: "",
      comuna_id: null as number | null,
      referencia: "",
      numero: "",
      bloque: "" as string | undefined,
      depto: "" as string | undefined,
      zona: "",
      zona_id: null as number | null,
      email: "",
      telefono: "",
      profesion: "" as string | undefined,
      ocupacion: "" as string | undefined,
      tarjeta: false,
      acreditacion: "",
      acreditacion_ext: "",
      carnet: "",
      carnet_ext: "",
      observacion: "",
      mensaje: "",
      titular: "",
      tipoVecino: null as number | null,
      step: 1,
      nombreEntidad: "" as string | undefined
    },
    authenticated: localStorage.getItem("auth_token") ? true : false,
    token: {
      auth_token: localStorage.getItem("auth_token") || "",
      refresh_token: localStorage.getItem("refresh_token") || ""
    },
    loading: true,
    cDisabled: false,
    cDisabledF: false,
    applicationRut: localStorage.getItem("applicationRut") || "",
    tarjeta: localStorage.getItem("tarjeta") || "",
    new: true,
    // BUSCADOR
    textBusqueda: "",
    modalBusqueda: false
  },
  getters: {
    fullname: state => {
      return `${state.user.username}`;
    }
  },
  mutations: {
    SET_USER(state, data) {
      Object.assign(state.user, data);
      localStorage.setItem("user", JSON.stringify(data));
      if (!state.user.lenguage) {
        state.user.lenguage = "es";
      }
    },
    UNSET_USER(state) {
      state.user = {
        id: "",
        username: "",
        rut: "",
        email: "",
        phone: "",
        lenguage: "es",
        direccion: "",
        calle: "",
        numero: "",
        zona: ""
      };
      state.cDisabled = true;
      state.cDisabledF = true;
    },
    SET_TOKEN(state, data) {
      Object.assign(state.token, data);
      state.authenticated = true;
    },
    UNSET_TOKEN(state) {
      state.token = {
        auth_token: "",
        refresh_token: ""
      };
      state.authenticated = false;
    },
    SET_LENGUAGE(state, data) {
      state.user.lenguage = data;
    },
    LOADING(state, data) {
      state.loading = data;
    },
    SET_PERMIT(state, data) {
      state.cDisabled = data;
    },
    SET_PERMIT_FLOAT(state, data) {
      state.cDisabledF = data;
    },
    SET_APPLICATION_RUT(state, data) {
      state.applicationRut = data;
      localStorage.setItem("applicationRut", data);
    },
    UNSET_APPLICATION_RUT(state, data) {
      state.applicationRut = "";
      localStorage.setItem("applicationRut", "");
    },
    SET_TARJETA(state, data) {
      state.tarjeta = data;
      localStorage.setItem("tarjeta", data);
    },
    UNSET_tarjeta(state, data) {
      state.tarjeta = "";
      localStorage.setItem("tarjeta", "");
    },
    SET_NEW(state, data) {
      state.new = data;
    },
    //BUSCADOR
    SET_TEXT_INPUT(state, data) {
      state.textBusqueda = data;
    },
    SET_MODAL_BUSCADOR(state, data) {
      state.modalBusqueda = data;
      if (data == false) {
        state.textBusqueda = "";
      }
    },
    SET_SOLICITUD_STEP_ONE(state) {
      state.solicitud.step = 1;
    },
    SET_SOLICITUD_STEP_TWO(state) {
      state.solicitud.step = 2;
    },
    SET_SOLICITUD_STEP_THREE(state) {
      state.solicitud.step = 3;
    },
    SET_SOLICITUD_STEP_FOUR(state) {
      state.solicitud.step = 4;
    },
    SET_SOLICITUD_STEP_FIVE(state) {
      state.solicitud.step = 5;
    },
    SET_DATOS_RUT(state, data) {
      (state.solicitud.mensaje = data.mensaje),
        (state.solicitud.titular = data.titular);
    },
    SET_DATOS_PERSONALES(state, data) {
      (state.solicitud.parentesco = data.parentesco),
        (state.solicitud.nombre = data.nombre),
        (state.solicitud.apellidoPaterno = data.apellidoPaterno),
        (state.solicitud.apellidoMaterno = data.apellidoMaterno),
        (state.solicitud.rut = data.rut),
        (state.solicitud.fechaNacimiento = data.fechaNacimiento),
        (state.solicitud.estadoCivil = data.estadoCivil),
        (state.solicitud.sexo = data.sexo),
        (state.solicitud.nacionalidad = data.nacionalidad),
        (state.solicitud.email = data.email),
        (state.solicitud.telefono = data.telefono),
        (state.solicitud.profesion = data.profesion),
        (state.solicitud.ocupacion = data.ocupacion),
        (state.solicitud.step = data.step),
        (state.solicitud.tipoVecino = data.tipoVecino),
        (state.solicitud.nombreEntidad = data.nombreEntidad);
    },
    SET_DIRECCION(state, data) {
      (state.solicitud.calle = data.calle),
        (state.solicitud.calle_id = data.calle_id),
        (state.solicitud.comuna = data.comuna),
        (state.solicitud.comuna_id = data.comuna_id),
        (state.solicitud.referencia = data.referencia),
        (state.solicitud.numero = data.numero),
        (state.solicitud.bloque = data.bloque),
        (state.solicitud.zona = data.zona),
        (state.solicitud.zona_id = data.zona_id),
        (state.solicitud.depto = data.depto);
    }
  },
  actions: {
    GET_USER({ commit, dispatch }, data) {
      const user = {
        id: data.id,
        username: data.username,
        rut: data.rut,
        email: data.email,
        phone: data.telefono,
        lenguage: data.idioma,
        direccion: data.direccion,
        calle: data.calle,
        numero: data.numero,
        zona: data.zona
      };
      commit("SET_USER", user);
    },
    LOGOUT({ commit, dispatch }) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("refresh_token");
      commit("UNSET_USER");
      const user = {
        id: "",
        name: "",
        family_name: "",
        rut: "",
        email: "",
        phone: "",
        lenguage: "",
        direccion: "",
        calle: "",
        numero: "",
        zona: ""
      };
      commit("SET_USER", user);
      commit("UNSET_TOKEN");
    },
    GET_PERMIT({ commit, dispatch }, list) {
      if (!list.length) {
        commit("SET_NEW", true);
        commit("SET_PERMIT", false);
        commit("SET_PERMIT_FLOAT", false);
      } else {
        commit("SET_NEW", false);
        const familyHead = list.find(
          (element: any) => element.jefeFamilia === "si"
        );
        const floatType = list.find((element: any) => element.tipoVecino !== 1);
        if (familyHead) {
          if (floatType) {
            if (list.length === 1) {
              commit("SET_PERMIT", true);
              commit("SET_PERMIT_FLOAT", true);
            } else {
              commit("SET_PERMIT", false);
              commit("SET_PERMIT_FLOAT", false);
            }
          } else {
            commit("SET_PERMIT", false);
            commit("SET_PERMIT_FLOAT", false);
          }
        } else {
          commit("SET_PERMIT", true);
          commit("SET_PERMIT_FLOAT", false);
        }
      }
    },
    SUBMIT_REQUEST_STEP_ONE({ commit }, payload) {
      commit("SET_DATOS_RUT", payload);
    },
    SUBMIT_REQUEST_STEP_TWO({ commit }, payload) {
      commit("SET_DATOS_PERSONALES", payload);
    },
    SUBMIT_REQUEST_STEP_THREE({ commit }, payload) {
      commit("SET_DIRECCION", payload);
    },
    SET_STATE_TO_ONE({ commit }) {
      commit("SET_SOLICITUD_STEP_ONE");
    },
    SET_STATE_TO_TWO({ commit }) {
      commit("SET_SOLICITUD_STEP_TWO");
    },
    SET_STATE_TO_THREE({ commit }) {
      commit("SET_SOLICITUD_STEP_THREE");
    },
    SET_STATE_TO_FOUR({ commit }) {
      commit("SET_SOLICITUD_STEP_FOUR");
    },
    SET_STATE_TO_FIVE({ commit }) {
      commit("SET_SOLICITUD_STEP_FIVE");
    }
  }
});
